<template>
  <v-container class="pa-6">
    <div style="margin-bottom: 24px;">
      <div class="component-title">{{ profile.name ? profile.name : profile.username }}</div>
      <v-breadcrumbs class="pa-0 ma-0" :items="items"
        ><template v-slot:divider class="pa-0">
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>
    <SaleInfo :profile="profile" :roles="roles" @refresh="refresh" />

    <SaleLeadTable ref="leadTable" :statusCount="statusCount" :query="filterQuery" />
  </v-container>
</template>
<script>
import {mapActions} from 'vuex'
import SaleInfo from './SaleInfo.vue'
import SaleLeadTable from './SaleLeadTable.vue'
export default {
  data() {
    return {
      profile: {},
      filterQuery: {},
      products: [],
      roles: [],
      statusCount: {
        countAll: 0,
        countNoContact: 0,
        countAppointmentSet: 0,
        countProductVerified: 0,
        countSucceed: 0,
        countFailed: 0
      },
      items: [
        {
          text: 'Danh sách nhân viên',
          disabled: false,
          href: '/admin/sale'
        },
        {
          text: 'Thông tin cá nhân',
          disabled: false
        }
      ]
    }
  },
  components: {
    SaleInfo,
    SaleLeadTable
  },
  mounted() {
    this.getProfileData()
    this.getRoles()
  },

  methods: {
    ...mapActions('user', ['fetchAdminUser']),
    ...mapActions('role', ['fetchRoles']),
    ...mapActions('lead', ['countStatus']),
    async getProfileData() {
      this.$loading.active = true
      const id = this.$route.params.id
      const countStatus = await this.countStatus({inCharge: this.$route.params.id})
      this.statusCount = countStatus
      const response = await this.fetchAdminUser(id)
      this.profile = response
      this.$loading.active = false
    },
    async getRoles() {
      this.$loading.active = true
      const roles = await this.fetchRoles()
      this.roles = roles.filter(role => role.type === 'admin' || role.type === 'sale')
    },
    refresh() {
      this.getProfileData()
    },
    onFilterChanged(query) {
      this.filterQuery = query
    }
  }
}
</script>

<style>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.v-breadcrumbs__divider {
  padding: 0 !important;
}
</style>
